<template>
  <div class="row event-item" @click="navigate">
    <div class="name">{{data.name}}</div>
    <div class="row footer">
      <div class="index">
        <span class="text">热度</span>
        <span class="val">{{data.index}}</span>
      </div>
      <div class="row count-container">
        <span class="count">{{data.count}}条相关新闻</span>
        <i class="icon el-icon-back"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    navigate() {
      this.$router.push({
        name: 'event-detail',
        query: {
          name: this.data.name,
          id: this.data.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.event-item {
  flex-direction: column;
  justify-content: space-between;
  width: 318px;
  height: 152px;
  padding: 24px 32px;
  background-color: #3e3c42;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background-color: #45434a;
  }
  .name {
    font-size: 20px;
    color: #ffffff;
    line-height: 28px;
  }
  .footer {
    justify-content: space-between;
    align-items: center;
    .index {
      font-size: 14px;
      color: #de5d66;
      line-height: 20px;
      .text {
        margin-right:4px;
      }
    }
    .count-container {
      align-items: center;
      font-size: 14px;
      color: #b1b1b3;
      line-height: 20px;
      .icon {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-left: 6px;
        transform: rotate(180deg);
      }
    }
  }
}
</style>
